//
//  useLogout.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import { useNavigate } from "react-router-dom";
import { postLogout } from "../network/api";
import { signOut } from "../network/firebase";
import { localStorageManager } from "../utils/localStorage";

export const useLogout = () => {
  const navigate = useNavigate();
  return async () => {
    // サーバサイドのリフレッシュトークン失効（CASA 2.2.1）。
    // interceptor が currentUser からIDトークンを付与するため signOut() より先に呼ぶ。
    // postLogout は内部で例外を握って成否を返すため、失敗してもローカルの破棄は継続する。
    await postLogout();
    await signOut();
    // 共用端末に被験者ID・所属グループ・CSV出力条件を残さない
    localStorageManager.clearAll();
    navigate("/Login");
  };
};
